import React from 'react';
import './Skeleton.css';

interface Props {
  variant: 'card' | 'row';
  count?: number;
}

function CardSkeleton() {
  return (
    <div className="skeleton-card">
      <div className="skeleton-card-top">
        <div className="skeleton-pulse skeleton-avatar" />
        <div className="skeleton-card-lines">
          <div className="skeleton-pulse skeleton-line skeleton-line--medium" />
          <div className="skeleton-pulse skeleton-line skeleton-line--short" />
        </div>
      </div>
      <div className="skeleton-pulse skeleton-bar" />
    </div>
  );
}

function RowSkeleton() {
  return (
    <div className="skeleton-row">
      <div className="skeleton-pulse skeleton-icon" />
      <div className="skeleton-row-lines">
        <div className="skeleton-pulse skeleton-line skeleton-line--long" />
        <div className="skeleton-pulse skeleton-line skeleton-line--short" />
      </div>
    </div>
  );
}

export default function Skeleton({ variant, count = 3 }: Props) {
  const items = Array.from({ length: count }, (_, i) => i);

  if (variant === 'card') {
    return (
      <div className="skeleton-cards">
        {items.map(i => <CardSkeleton key={i} />)}
      </div>
    );
  }

  return (
    <div className="skeleton-rows">
      {items.map(i => <RowSkeleton key={i} />)}
    </div>
  );
}
